import SearchBox, { Props } from './SearchBox';

export { SearchBox, Props };
